import { t } from "i18next";
import React from "react";
import { createPortal } from "react-dom";

import permissionsIcon from "@/assets/browser-permission.png";
import curvedArrow from "@/assets/curved_arrow.svg";

interface PermissionArrowProps {
    isVisible: boolean;
}

export const PermissionArrow: React.FC<PermissionArrowProps> = ({ isVisible }) => {
    if (!isVisible) return null;

    return createPortal(
        <div className="fixed top-2 left-[350px] -translate-x-1/2 pointer-events-none z-[var(--z-guided-tour)]">
            <img src={curvedArrow} alt="Curved Arrow" className="w-auto h-24 -rotate-45 text-[#f4f4f4]" />
            <p className="text-lg text-[#f4f4f4] mt-2">
                <img src={permissionsIcon} alt="Permissions Icon" className="w-auto h-12 mr-2 rounded-3xl" />
                {t("click_to_grant_permissions")}
            </p>
        </div>,
        document.body
    );
};
